import { EmptyState } from '@/components/ui/EmptyState';
import { PageHeading } from '@/components/ui/PageHeading';
import { TicketEventCard } from '../components/TicketEventCard';
import { useTicketEvents } from '../api';
import '../tickets.css';

/**
 * Open and upcoming ticket events, in the server's order: running first, then
 * upcoming, then finished.
 *
 * Finished events do not vanish — a member who deposited and is waiting for a
 * review needs to find the page again — but they sit last, under no promise.
 */
export function TicketEventsPage() {
  const { data, isLoading, isError } = useTicketEvents();

  const running = data?.filter((event) => event.phase === 'running') ?? [];
  const upcoming = data?.filter((event) => event.phase === 'upcoming') ?? [];
  const ended = data?.filter((event) => event.phase === 'ended') ?? [];

  return (
    <div className="w-full py-2">
      <PageHeading
        kind="gem"
        eyebrow="Biletini topla"
        title="Bilet Etkinlikleri"
        description="Güvenilir sitelerde yatırım yap, bilet kazan. Yatırımını gönder, onaylandığında biletlerin çekilişe sayılsın."
      />

      {isLoading ? (
        <div className="grid gap-4 sm:grid-cols-2">
          {Array.from({ length: 2 }, (_, index) => (
            <div key={index} className="h-64 animate-pulse rounded-[var(--radius-card)] bg-surface-900/60" />
          ))}
        </div>
      ) : isError ? (
        <EmptyState title="Etkinlikler yüklenemedi." description="Lütfen sayfayı yenileyin." />
      ) : data && data.length > 0 ? (
        <div className="space-y-8">
          {running.length > 0 ? (
            <section aria-labelledby="running-events">
              <h2 id="running-events" className="section-title">
                Devam eden etkinlikler
              </h2>
              <div className="mt-4 grid gap-4 sm:grid-cols-2">
                {running.map((event) => (
                  <TicketEventCard key={event.id} event={event} />
                ))}
              </div>
            </section>
          ) : null}

          {upcoming.length > 0 ? (
            <section aria-labelledby="upcoming-events">
              <h2 id="upcoming-events" className="section-title">
                Yaklaşan etkinlikler
              </h2>
              <div className="mt-4 grid gap-4 sm:grid-cols-2">
                {upcoming.map((event) => (
                  <TicketEventCard key={event.id} event={event} />
                ))}
              </div>
            </section>
          ) : null}

          {ended.length > 0 ? (
            <section aria-labelledby="ended-events">
              <h2 id="ended-events" className="section-title">
                Sona erenler
              </h2>
              <div className="mt-4 grid gap-4 sm:grid-cols-2">
                {ended.map((event) => (
                  <TicketEventCard key={event.id} event={event} />
                ))}
              </div>
            </section>
          ) : null}
        </div>
      ) : (
        <EmptyState
          title="Şu anda açık bir bilet etkinliği yok."
          description="Yenisi başladığında burada olacak."
        />
      )}
    </div>
  );
}
